module.exports = __webpack_public_path__ + "static/img/comunicado_corte_servicios.d41dd42.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/comunicado_corte_servicios.jpg
// module id = VcYd
// module chunks = 9